// extracted by mini-css-extract-plugin
module.exports = {"link":"arrow-link_link__S_5WW","text":"arrow-link_text__uGkYH"};